export const focusField = (name: string) => {
  const fieldName = name === 'travellers' ? 'travellers-trigger' : name;

  const selector = `#RailwaysSearchForm [name="${fieldName}"]`;
  const element: HTMLInputElement | null = document.querySelector(selector);

  if (element) {
    element.focus();
  }
};
